export const RDM_COMMAND_TYPE = {
  CLEAR_CACHE: "device.clear_cache",
  REBOOT: "device.reboot",
  RESTART_PLAYER_APP: "device.restart_player_app",
  SET_MUTE: "device.set_mute",
  STATE_REPORT: "device.state.report",
  SCREENSHOT: "screen.capture",
  OS_CHANNEL: "os.channel",
  GET_TIMEZONE_LIST: "time.get_timezone_list",
  SET_TIMEZONE: "time.set_timezone",
  PASSCODE_SET: "passcode.set",
  PASSCODE_GET_SETTINGS: "passcode.get_settings",
  SCAN_WIFI: "network.scan_wifi",
  CONNECT_WIFI: "network.connect_wifi",
  CONNECT_ETHERNET: "network.connect_ethernet",
  DATETIME_NTP_SET: "datetime.ntp.set",
  DISPLAY_GET_MODES: "display.get_modes",
  DISPLAY_SET_MODE: "display.set_mode",
  DISPLAY_GET_SCALES: "display.get_scales",
  DISPLAY_SET_SCALE: "display.set_scale",
  DISPLAY_GET_CONFIG: "display.get_config",
  GET_DEVICE_HOSTNAME: "device.name.get",
  SET_DEVICE_HOSTNAME: "device.name.set",
  SET_DAILY_RESTART: "settings.set_daily_restart",
  CEC_GET_TV_RUNTIME_STATUS: "cec.get_tv_runtime_status",
  CEC_QUERY_TV_POWER_STATUS: "cec.query_tv_power_status",
  CEC_TV_WAKE: "cec.tv_wake",
  CEC_TV_STANDBY: "cec.tv_standby",
  CEC_LOCK_INPUT: "cec.lock_input",
  CEC_UNLOCK_INPUT: "cec.unlock_input",
} as const;

export type RdmCommandType =
  (typeof RDM_COMMAND_TYPE)[keyof typeof RDM_COMMAND_TYPE];

const QUIET_COMMANDS: readonly string[] = [
  RDM_COMMAND_TYPE.STATE_REPORT,
  RDM_COMMAND_TYPE.GET_TIMEZONE_LIST,
  RDM_COMMAND_TYPE.PASSCODE_GET_SETTINGS,
  RDM_COMMAND_TYPE.SCAN_WIFI,
  RDM_COMMAND_TYPE.CONNECT_WIFI,
  RDM_COMMAND_TYPE.CONNECT_ETHERNET,
  RDM_COMMAND_TYPE.DATETIME_NTP_SET,
  RDM_COMMAND_TYPE.DISPLAY_GET_MODES,
  RDM_COMMAND_TYPE.DISPLAY_GET_SCALES,
  RDM_COMMAND_TYPE.DISPLAY_GET_CONFIG,
  RDM_COMMAND_TYPE.GET_DEVICE_HOSTNAME,
  RDM_COMMAND_TYPE.CEC_GET_TV_RUNTIME_STATUS,
  RDM_COMMAND_TYPE.CEC_QUERY_TV_POWER_STATUS,
  RDM_COMMAND_TYPE.CEC_TV_WAKE,
  RDM_COMMAND_TYPE.CEC_TV_STANDBY,
  RDM_COMMAND_TYPE.CEC_LOCK_INPUT,
  RDM_COMMAND_TYPE.CEC_UNLOCK_INPUT,
];

/** No toast, and no getScreenDeviceState refetch on COMPLETED. */
export function isQuietCommand(
  commandType: string | null | undefined,
): boolean {
  return commandType != null && QUIET_COMMANDS.includes(commandType);
}
